import {defineStore} from 'pinia';

import {fetchWrapper} from '@/helpers/fetch-wrapper';
import {showSuccessToast} from "vant";


const baseUrl = `${process.env.VUE_APP_API_URL}/notification/groups`;

export const useUserSettingStore = defineStore({
    id: 'userSetting',
    state: () => ({
        userNotificationSettings: [],
        userNotificationSetting: {},
    }),
    actions: {
        async fetchAll() {
            const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
            const response = await fetchWrapper.get(`${baseUrl}/` + '?account_id=' + accountId, null);
            this.userNotificationSettings = response.data;
        },

        async updateResource(id, action) {
            const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
            const response = await fetchWrapper.put(`${baseUrl}/` + id + '/' + action + "?account_id=" + accountId, {});
            this.userNotificationSetting = response.data;
            showSuccessToast('Updated');
        },
    }
});
